// extracted by mini-css-extract-plugin
module.exports = {"Ass":"App_Ass__iaXFo"};